const POShipmentDraftSearchType = {
  GET_SHIPMENT_DRAFT_INFO_LIST: 'GET_SHIPMENT_DRAFT_INFO_LIST',
  GET_SHIPMENT_DRAFT_INFO_LIST_SUCCESS: 'GET_SHIPMENT_DRAFT_INFO_LIST_SUCCESS',
  GET_SHIPMENT_DRAFT_INFO_LIST_FAIL: 'GET_SHIPMENT_DRAFT_INFO_LIST_FAIL',
  GET_SHIPMENT_DRAFT_INFO_LIST_RESET: 'GET_SHIPMENT_DRAFT_INFO_LIST_RESET',
  UPDATE_SHIPMENT_DRAFT_INFO_LIST_REQUEST: 'UPDATE_SHIPMENT_DRAFT_INFO_LIST_REQUEST',

  UPDATE_SHIPMENT_DRAFT_INFO_LIST_CHECKED_ITEMS: 'UPDATE_SHIPMENT_DRAFT_INFO_LIST_CHECKED_ITEMS',

  SET_SHIPEMENT_DRAFT_SEARCH_EXPORT_TOGGLE: 'SET_SHIPEMENT_DRAFT_SEARCH_EXPORT_TOGGLE',
};

export default POShipmentDraftSearchType;
